/* Lorelia Startseite 2026 · Gravur, Himmel, Stadt, Foto im Stein (freigegeben 02.10.2026, Vorlage: ideen-v2/vorschau-v2.html).
   Jeder Abschnitt startet erst, wenn er im Bild ist, und pausiert außerhalb (keine Arbeit im Hintergrund).
   Bei reduzierter Bewegung: Standbild ohne Wechsel. Nichts hängt am Scrollen. */
(function () {
  'use strict';
  var RUHIG = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var NS = 'http://www.w3.org/2000/svg';
  function el(n, a, p) { var e = document.createElementNS(NS, n); for (var k in a) e.setAttribute(k, a[k]); if (p) p.appendChild(e); return e; }
  function beobachten(e, cb) {
    if (!('IntersectionObserver' in window)) return cb(true);
    new IntersectionObserver(function (x) { cb(x[0].isIntersecting); }, { threshold: 0.15 }).observe(e);
  }
  function woerter(e, txt) {
    e.textContent = '';
    txt.split(' ').forEach(function (w, i) {
      var s = document.createElement('span'); s.className = 'lr26-id__wort'; s.style.animationDelay = (i * 0.05) + 's'; s.textContent = w;
      e.appendChild(s); e.appendChild(document.createTextNode(' '));
    });
  }
  function daten(root) { try { return JSON.parse(root.querySelector('script[type="application/json"]').textContent); } catch (e) { return {}; } }

  /* ---------- 1 · Gravur: Name aufs Poster + Gravur ins ECHTE Foto des Rings VEDA (04.10.2026, P1-49) ---------- */
  var nr = 0;
  function pfadAus(p) { // Catmull-Rom → Bézier, Punkte von unten nach oben (Schrift liest wie auf dem Produktfoto)
    var d = 'M' + p[0][0] + ',' + p[0][1];
    for (var i = 0; i < p.length - 1; i++) {
      var a = p[i - 1] || p[i], b = p[i], c = p[i + 1], e = p[i + 2] || c;
      d += ' C' + (b[0] + (c[0] - a[0]) / 6).toFixed(1) + ',' + (b[1] + (c[1] - a[1]) / 6).toFixed(1) + ' ' + (c[0] - (e[0] - b[0]) / 6).toFixed(1) + ',' + (c[1] - (e[1] - b[1]) / 6).toFixed(1) + ' ' + c[0] + ',' + c[1];
    }
    return d;
  }
  function gravur(root) {
    var svg = root.querySelector('[data-ring]'), bild = root.querySelector('[data-ring-bild]'), ein = root.querySelector('input'), pName = root.querySelector('[data-poster-name]');
    var chips = [].slice.call(root.querySelectorAll('.lr26-id__chip'));
    var liste = chips.map(function (c) { return c.getAttribute('data-n'); });
    var RINGE = daten(root).ringe || {};
    // Farben aus den echten Gravuren der Produktfotos gemessen (Gold dunkel #61 3C 05, Silber #34 34 34)
    var FARBE = { gold: { grund: '#C3964A', kante: '#5A3A08', licht: '#FFF3D2' }, silber: { grund: '#A9ACB1', kante: '#3E4146', licht: '#FFFFFF' } };
    var basis = 'g' + (++nr), defs = el('defs', {}, svg);
    var glut = el('filter', { id: basis + 'glut', x: '-50%', y: '-50%', width: '200%', height: '200%' }, defs); el('feGaussianBlur', { stdDeviation: '2.4' }, glut);
    var korn = el('filter', { id: basis + 'korn', x: '0', y: '0', width: '100%', height: '100%' }, defs);
    el('feTurbulence', { type: 'fractalNoise', baseFrequency: '0.9', numOctaves: '2', seed: '7', result: 'n' }, korn);
    el('feColorMatrix', { in: 'n', type: 'matrix', values: '0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.55 0', result: 'k' }, korn);
    el('feComposite', { in: 'k', in2: 'SourceAlpha', operator: 'in', result: 'kk' }, korn);
    var mg = el('feMerge', {}, korn); el('feMergeNode', { in: 'SourceGraphic' }, mg); el('feMergeNode', { in: 'kk' }, mg);
    var modus = 'eins', rn = 0;
    function band(cfg, name) {
      var id = basis + 'r' + (++rn), d = pfadAus(cfg.p), F = FARBE[cfg.m] || FARBE.gold;
      var g = el('g', { 'data-gravur': '' }, svg);
      var pfad = el('path', { id: 'p' + id, d: d, fill: 'none' }, defs);
      var mk = el('mask', { id: 'm' + id, maskUnits: 'userSpaceOnUse', x: 0, y: 0, width: 2000, height: 2000 }, defs);
      var mstrich = el('path', { d: d, fill: 'none', stroke: '#fff', 'stroke-width': cfg.fs * 1.6 }, mk);
      var t = el('g', { mask: 'url(#m' + id + ')' }, g);
      var schrift = { 'font-family': '"LR Cormorant","Cormorant Garamond",Georgia,serif', 'font-weight': 500, 'letter-spacing': (cfg.fs * 0.07).toFixed(1) };
      // echte Länge ohne Pfad messen (auf dem Pfad liefert WebKit nur den sichtbaren Teil → Namen wurden abgeschnitten)
      var pfad0 = pfad.getTotalLength(), max = pfad0 * 0.8, fs = cfg.fs;
      var mess = el('text', Object.assign({ 'font-size': fs, x: -9999, y: -9999 }, schrift), svg); mess.textContent = name.toUpperCase();
      var roh = mess.getComputedTextLength(); mess.remove();
      if (roh > max) { fs = fs * max / roh; roh = max; }
      var dd = (fs * 0.05).toFixed(2), dick = (fs * 0.03).toFixed(2);
      function text(fill, dx, dy, extra) {
        var a = Object.assign({ fill: fill, stroke: fill, 'stroke-width': dick, 'stroke-linejoin': 'round', 'font-size': fs.toFixed(1), 'letter-spacing': (fs * 0.07).toFixed(1), 'dominant-baseline': 'central', transform: 'translate(' + dx + ' ' + dy + ')' }, schrift, extra || {});
        a['letter-spacing'] = (fs * 0.07).toFixed(1);
        var tx = el('text', a), tp = el('textPath', { href: '#p' + id, startOffset: '50%', 'text-anchor': 'middle' }, tx); tp.textContent = name.toUpperCase(); return tx;
      }
      // Kantenmasken: Schatten nur am oberen linken Innenrand, Licht nur am unteren rechten Innenrand der Buchstaben
      function kantenMaske(mid, dx, dy) {
        var m = el('mask', { id: mid, maskUnits: 'userSpaceOnUse', x: 0, y: 0, width: 2000, height: 2000 }, defs);
        el('rect', { x: 0, y: 0, width: 2000, height: 2000, fill: '#fff' }, m); m.appendChild(text('#000', dx, dy)); return 'url(#' + mid + ')';
      }
      var grund = text(F.grund, 0, 0, { style: 'mix-blend-mode:multiply', filter: 'url(#' + basis + 'korn)' }); t.appendChild(grund);
      var schatten = text(F.kante, 0, 0, { style: 'mix-blend-mode:multiply', opacity: 0.7, mask: kantenMaske('ks' + id, dd, dd) }); t.appendChild(schatten);
      var licht = text(F.licht, 0, 0, { style: 'mix-blend-mode:screen', opacity: 0.9, mask: kantenMaske('kl' + id, -dd, -dd) }); t.appendChild(licht);
      var L = pfad0, tl = roh + fs * 0.5, s0 = Math.max(0, (L - tl) / 2);
      mstrich.setAttribute('stroke-dasharray', '0 ' + L); mstrich.setAttribute('stroke-dashoffset', -s0);
      var funke = el('circle', { r: 4, fill: '#FFF8E6', filter: 'url(#' + basis + 'glut)', opacity: 0 }, g), kern = el('circle', { r: 1.8, fill: '#fff', opacity: 0 }, g);
      return { g: g, mstrich: mstrich, s0: s0, tl: tl, L: L, pfad: pfad, funke: funke, kern: kern };
    }
    function gravieren(r, dauer, fertig) {
      if (RUHIG) { r.mstrich.setAttribute('stroke-dasharray', r.tl + ' ' + r.L); return fertig && fertig(); }
      var t0 = performance.now();
      (function s(t) {
        var p = Math.min((t - t0) / dauer, 1), e = 1 - Math.pow(1 - p, 2), dd = r.tl * e; r.mstrich.setAttribute('stroke-dasharray', dd.toFixed(1) + ' ' + r.L);
        var pt = r.pfad.getPointAtLength(Math.min(r.L, r.s0 + dd)), an = p < 1 ? 1 : 0;
        r.funke.setAttribute('cx', pt.x); r.funke.setAttribute('cy', pt.y); r.kern.setAttribute('cx', pt.x); r.kern.setAttribute('cy', pt.y);
        r.funke.setAttribute('opacity', an * (0.6 + Math.random() * 0.3)); r.kern.setAttribute('opacity', an * 0.9);
        if (p < 1) requestAnimationFrame(s); else fertig && fertig();
      })(t0);
    }
    var auftrag = 0;
    function zeigen(t) {
      var a = ++auftrag; t = (t || '').replace(/\s+/g, ' ').trim(); pName.textContent = t.toUpperCase();
      chips.forEach(function (c) { c.setAttribute('aria-pressed', String(c.getAttribute('data-n') === t)); });
      [].slice.call(svg.querySelectorAll('[data-gravur]')).forEach(function (g) { g.remove(); });
      var namen = t.split(/\s*(?:&|\+|\bund\b)\s*/i).filter(Boolean).slice(0, 2); if (!namen.length) return;
      var m = namen.length === 1 ? 'eins' : 'zwei', R = RINGE[m]; if (!R) return;
      if (m !== modus) { modus = m; bild.setAttribute('href', R.b); svg.setAttribute('viewBox', '0 0 ' + R.w + ' ' + R.h); bild.setAttribute('width', R.w); bild.setAttribute('height', R.h); }
      var ringe = namen.map(function (n, i) { return band(R.baender[i], n); });
      var dauer = namen.length === 1 ? 950 : 750;
      gravieren(ringe[0], dauer, function () { if (a !== auftrag) return; if (ringe[1]) gravieren(ringe[1], dauer, null); });
    }
    if (RINGE.zwei) { var vor = new Image(); vor.src = RINGE.zwei.b; }
    var demo = !RUHIG, di = 0, demoT = null, tippT = null, imBild = false;
    function demoAus() { demo = false; clearTimeout(demoT); }
    function tippen(ziel, dann) {
      var i = 0;
      (function s() { if (!demo) return; ein.value = ziel.slice(0, ++i); pName.textContent = ein.value.toUpperCase(); if (i < ziel.length) demoT = setTimeout(s, 55); else { zeigen(ziel); dann && dann(); } })();
    }
    function demoWeiter() { if (!demo) return; clearTimeout(demoT); demoT = setTimeout(function () { if (!imBild) return; di = (di + 1) % liste.length; tippen(liste[di], demoWeiter); }, 3400); }
    ein.addEventListener('focus', demoAus);
    ein.addEventListener('input', function () { demoAus(); pName.textContent = ein.value.toUpperCase(); clearTimeout(tippT); tippT = setTimeout(function () { zeigen(ein.value); }, 380); });
    chips.forEach(function (c) { c.addEventListener('click', function () { demoAus(); ein.value = c.getAttribute('data-n'); zeigen(ein.value); }); });
    // Einflug: EINMAL, wenn der Abschnitt ins Bild kommt (Klasse nur per JS, ohne JS steht alles still da)
    if (!RUHIG) root.classList.add('ist-bereit');
    var gestartet = false;
        function start() { if (gestartet) return; gestartet = true; setTimeout(function () { zeigen(liste[0] || 'Emma'); demoWeiter(); }, RUHIG ? 0 : 650); }
    beobachten(root, function (an) {
      imBild = an;
      if (an) { root.classList.add('ist-da'); if (document.fonts && document.fonts.ready) document.fonts.ready.then(start); else start(); if (gestartet && demo) demoWeiter(); }
    });
  }

  /* ---------- 2 · Himmel: echte Sternenkarten, drehend, mit Funkeln ---------- */
  function himmel(root) {
    var MOM = daten(root).momente || [];
    MOM.forEach(function (m) { var i = new Image(); i.src = m.b; });
    var kranz = root.querySelector('[data-kranz]');
    el('circle', { cx: 100, cy: 100, r: 97, fill: 'none', stroke: 'rgba(138,101,32,.5)', 'stroke-width': 0.6 }, kranz);
    for (var gr = 0; gr < 360; gr += 5) {
      var lang = gr % 30 === 0, r1 = lang ? 90.5 : 93, a = gr * Math.PI / 180;
      el('line', { x1: (100 + Math.cos(a) * r1).toFixed(2), y1: (100 + Math.sin(a) * r1).toFixed(2), x2: (100 + Math.cos(a) * 96).toFixed(2), y2: (100 + Math.sin(a) * 96).toFixed(2), stroke: 'rgba(138,101,32,' + (lang ? 0.75 : 0.4) + ')', 'stroke-width': lang ? 0.7 : 0.4 }, kranz);
    }
    [['N', 270], ['O', 0], ['S', 90], ['W', 180]].forEach(function (x) {
      var a = x[1] * Math.PI / 180, t = el('text', { x: (100 + Math.cos(a) * 85).toFixed(1), y: (100 + Math.sin(a) * 85 + 2).toFixed(1), 'text-anchor': 'middle', 'font-size': 6, fill: '#8A6520', 'font-family': '"LR Jost",Jost,sans-serif', 'letter-spacing': 1 }, kranz);
      t.textContent = x[0];
    });
    var karte = root.querySelector('[data-karte]'), hT = root.querySelector('[data-titel]'), hZ = root.querySelector('[data-zeile]');
    var chips = [].slice.call(root.querySelectorAll('.lr26-id__chip')), akt = 0, auto = !RUHIG, autoT = null, imBild = false;
    function wahl(i) {
      akt = i; var m = MOM[i]; if (!m) return;
      chips.forEach(function (c) { c.setAttribute('aria-pressed', String(+c.getAttribute('data-i') === i)); });
      var alt = karte.querySelector('img:last-child'), neu = new Image(); neu.src = m.b; neu.alt = 'Sternenkarte ' + m.z; neu.decoding = 'async';
      if (!RUHIG) neu.className = 'ist-wirbel'; karte.appendChild(neu);
      if (alt) { alt.classList.add('ist-weg'); setTimeout(function () { alt.remove(); }, 500); }
      setTimeout(function () { neu.classList.remove('ist-wirbel'); }, 900);
      woerter(hT, m.t); woerter(hZ, m.z);
    }
    chips.forEach(function (c) { c.addEventListener('click', function () { auto = false; clearTimeout(autoT); wahl(+c.getAttribute('data-i')); }); });
    function weiter() { clearTimeout(autoT); if (!auto || !imBild) return; autoT = setTimeout(function () { wahl((akt + 1) % MOM.length); weiter(); }, 3200); }
    var fc = root.querySelector('canvas'), fx = fc.getContext('2d'), funken = [], schnuppe = null, letzteS = 0, laeuft = false;
    function groesse() { var r = fc.getBoundingClientRect(), d = Math.min(window.devicePixelRatio || 1, 2); fc.width = Math.max(1, r.width * d); fc.height = Math.max(1, r.height * d); fx.setTransform(d, 0, 0, d, 0, 0); }
    for (var k = 0; k < 26; k++) funken.push({ x: Math.random(), y: Math.random(), p: Math.random() * 6.28, v: 0.03 + Math.random() * 0.05 });
    function bild(t) {
      if (!imBild) { laeuft = false; return; }
      var w = fc.clientWidth, h = fc.clientHeight; fx.clearRect(0, 0, w, h);
      funken.forEach(function (s) {
        s.p += s.v; var a = Math.max(0, Math.sin(s.p)); if (a < 0.05) return;
        var x = s.x * w, y = s.y * h, r = 0.8 + a * 1.4, g = fx.createRadialGradient(x, y, 0, x, y, r * 3);
        g.addColorStop(0, 'rgba(255,250,232,' + (a * 0.95) + ')'); g.addColorStop(0.35, 'rgba(255,240,205,' + (a * 0.35) + ')'); g.addColorStop(1, 'rgba(255,248,225,0)');
        fx.fillStyle = g; fx.beginPath(); fx.arc(x, y, r * 3, 0, 7); fx.fill();
        fx.strokeStyle = 'rgba(255,250,232,' + (a * 0.6) + ')'; fx.lineWidth = 0.6; fx.beginPath(); fx.moveTo(x - r * 3.4, y); fx.lineTo(x + r * 3.4, y); fx.moveTo(x, y - r * 3.4); fx.lineTo(x, y + r * 3.4); fx.stroke();
      });
      if (!schnuppe && t - letzteS > 2600) { letzteS = t; schnuppe = { x: Math.random() * w * 0.6 + w * 0.1, y: Math.random() * h * 0.3 + h * 0.1, l: 0 }; }
      if (schnuppe) {
        schnuppe.l += 0.035; var sx = schnuppe.x + schnuppe.l * w * 0.35, sy = schnuppe.y + schnuppe.l * h * 0.22, g2 = fx.createLinearGradient(sx - 50, sy - 31, sx, sy);
        g2.addColorStop(0, 'rgba(255,240,200,0)'); g2.addColorStop(1, 'rgba(255,248,230,' + (1 - schnuppe.l) + ')');
        fx.strokeStyle = g2; fx.lineWidth = 1.6; fx.beginPath(); fx.moveTo(sx - 50, sy - 31); fx.lineTo(sx, sy); fx.stroke(); if (schnuppe.l >= 1) schnuppe = null;
      }
      requestAnimationFrame(bild);
    }
    window.addEventListener('resize', groesse);
    beobachten(root, function (an) {
      imBild = an;
      if (an) { groesse(); weiter(); if (!RUHIG && !laeuft) { laeuft = true; requestAnimationFrame(bild); } }
      else clearTimeout(autoT);
    });
  }

  /* ---------- 3 · Stadt: echte Karte im Herz, Nadel fällt ein ---------- */
  function stadt(root) {
    var ST = daten(root).staedte || [];
    ST.forEach(function (s) { var i = new Image(); i.src = s.b; });
    var bildF = root.querySelector('[data-bild]'), sN = root.querySelector('[data-stadt]'), sK = root.querySelector('[data-koord]');
    var nadel = root.querySelector('[data-nadel]'), welle = root.querySelector('[data-welle]'), si = 0, takt = null, imBild = false, gestartet = false;
    function buchstaben(e, txt) {
      e.textContent = '';
      for (var i = 0; i < txt.length; i++) { var s = document.createElement('span'); s.className = 'lr26-id__wort'; s.style.animationDelay = (i * 0.035) + 's'; s.textContent = txt[i]; e.appendChild(s); }
    }
    function tippKoord(txt) { var i = 0; (function s() { sK.textContent = txt.slice(0, ++i); if (i < txt.length) setTimeout(s, 18); })(); }
    function zeigen(i) {
      si = i; var s = ST[i]; if (!s) return;
      var alt = bildF.querySelector('img:last-child'), neu = new Image(); neu.src = s.b; neu.alt = 'Stadtkarte ' + s.n + ' im Lorelia-Stil'; neu.decoding = 'async';
      if (RUHIG) { bildF.textContent = ''; bildF.appendChild(neu); sN.textContent = s.n; sK.textContent = s.k; return; }
      neu.className = 'ist-neu'; bildF.appendChild(neu); if (alt) { alt.className = 'ist-alt'; setTimeout(function () { alt.remove(); }, 780); }
      nadel.classList.remove('ist-fallend'); welle.classList.remove('ist-an'); void nadel.getBoundingClientRect(); nadel.classList.add('ist-fallend'); welle.classList.add('ist-an');
      buchstaben(sN, s.n); tippKoord(s.k);
    }
    beobachten(root, function (an) {
      imBild = an; clearInterval(takt);
      if (!an) return;
      if (!gestartet) { gestartet = true; zeigen(0); }
      if (!RUHIG) takt = setInterval(function () { zeigen((si + 1) % ST.length); }, 2600);
    });
  }

  /* ---------- 4 · Foto im Stein: echtes SAGA-Foto, Licht → Foto leuchtet im Stein auf (04.10.2026, P1-49) ---------- */
  function stein(root) {
    var FO = daten(root).fotos || [];
    FO.forEach(function (f) { var i = new Image(); i.src = f.b; });
    var feld = root.querySelector('[data-stein]'), licht = feld.querySelector('.lr26-sn__licht'), txt = root.querySelector('[data-stein-text]');
    var knoepfe = [].slice.call(root.querySelectorAll('[data-stein-punkte] button')), akt = 0, auto = !RUHIG, takt = null, imBild = false, gestartet = false;
    function zeigen(i) {
      var f = FO[i]; if (!f) return;
      if (i === akt && feld.querySelector('.lr26-sn__foto.ist-an')) return;   /* gleiches Motiv nicht doppelt einblenden */
      akt = i;
      knoepfe.forEach(function (b, n) { b.classList.toggle('an', n === i); b.setAttribute('aria-pressed', String(n === i)); });
      var alt = feld.querySelector('.lr26-sn__foto.ist-an'), neu = document.createElement('img');
      neu.className = 'lr26-sn__foto'; neu.alt = ''; neu.decoding = 'async'; neu.src = f.b; feld.insertBefore(neu, licht);
      if (alt) { alt.classList.remove('ist-an'); setTimeout(function () { alt.remove(); }, 950); }
      if (RUHIG) { neu.classList.add('ist-an'); txt.textContent = f.t; return; }
      licht.classList.remove('ist-an'); void licht.offsetWidth; licht.classList.add('ist-an');
      setTimeout(function () { neu.classList.add('ist-an'); }, 220);
      woerter(txt, f.t);
    }
    function weiter() { clearTimeout(takt); if (!auto || !imBild) return; takt = setTimeout(function () { zeigen((akt + 1) % FO.length); weiter(); }, 3600); }
    var kette = root.querySelector('.lr26-sn__kette'), erst = feld.querySelector('.lr26-sn__foto');
    if (erst && !RUHIG) erst.remove();
    function kettenBereit(cb) { if (!kette || kette.complete) return cb(); kette.addEventListener('load', cb, { once: true }); kette.addEventListener('error', cb, { once: true }); }
    knoepfe.forEach(function (b, n) { b.addEventListener('click', function () { auto = false; clearTimeout(takt); zeigen(n); }); });
    beobachten(root, function (an) {
      imBild = an;
      if (!an) { clearTimeout(takt); return; }
      if (!gestartet) { gestartet = true; if (RUHIG) return; kettenBereit(function () { setTimeout(function () { zeigen(0); weiter(); }, 250); }); }
      else weiter();
    });
  }

  function start() {
    [].forEach.call(document.querySelectorAll('[data-lr26-idee]'), function (r) {
      if (r.getAttribute('data-gestartet')) return; r.setAttribute('data-gestartet', '1');
      var art = r.getAttribute('data-lr26-idee');
      try { if (art === 'gravur') gravur(r); else if (art === 'himmel') himmel(r); else if (art === 'stadt') stadt(r); else if (art === 'stein') stein(r); } catch (e) { if (window.console) console.warn('lr26-ideen', art, e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
